import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { PagerdutyConnector } from '../../connector';

export const PagerdutyService = IntegrationService.make({
  connector: PagerdutyConnector,
  name: Integration_Service_Names_Enum.Pagerduty,
});
